import request from './request';

const uri = 'stats/';

const stats = {
  get: (id = '', options) => request(uri + id, options),
};

export default stats;
